import { create } from 'zustand'

type UserContactsStore = {
  selectedProjects?: string[]
  setSelectedProjects: (types?: string[]) => void
}

export const useUserContactsStore = create<UserContactsStore>(set => ({
  selectedProjects: undefined,
  setSelectedProjects: selectedProjects => set(() => ({ selectedProjects }))
}))
